import questionConstants from '../../../views/questions/constants';
const constantQuestionTypesContent = {
  QUESTION_TYPE_STEP: {
    CHOOSE_QUESTION_TYPE: questionConstants.QUESTION_TYPE_STEP.CHOOSE_QUESTION_TYPE,
    START_QUESTION_TYPE: questionConstants.QUESTION_TYPE_STEP.START_QUESTION_TYPE,
    CHANGE_MODEL: questionConstants.QUESTION_TYPE_STEP.CHANGE_MODEL,
    MAP: questionConstants.QUESTION_TYPE_STEP.MAP
  },
  QUESTION_TYPES: {
    MULTIPLE_CHOICE: questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE,
    SATISFACTION: questionConstants.QUESTION_TYPES.SATISFACTION,
    PERCENTAGE: questionConstants.QUESTION_TYPES.PERCENTAGE,
    MULTIPLE_SELECT: questionConstants.QUESTION_TYPES.MULTIPLE_SELECT,
    STACK_RANKING: questionConstants.QUESTION_TYPES.STACK_RANKING,
    OPEN_TEXT: questionConstants.QUESTION_TYPES.OPEN_TEXT
  }
};

export const completedTabs = [
  {
    'id': 0,
    'header': 'Survey Type',
    'subHeader': '',
    'tableHeader': 'select Survey Type',
    'placeholderSearchText': 'Search Survey Type',
    'step': 'SURVEY_TYPE',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 1,
    'header': 'Path',
    'subHeader': '',
    'tableHeader': 'select Path',
    'placeholderSearchText': 'Search Path',
    'step': 'PATH',
    'showLegend': false,
    'showSkipButton': true,
    'labelSkipButton': 'Skip To Practice',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 2,
    'header': 'Practice',
    'subHeader': '',
    'tableHeader': 'select Practice',
    'placeholderSearchText': 'Search Practice',
    'step': 'PRACTICE',
    'showLegend': true,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 3,
    'header': 'Step',
    'subHeader': '',
    'tableHeader': 'select Step',
    'placeholderSearchText': 'Search Step',
    'step': 'STEP',
    'showLegend': true,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': true,
    'labelLongFormSurveyButton': 'Create A Long Survey',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 4,
    'header': 'Elements',
    'subHeader': '',
    'tableHeader': 'Name Survey',
    'step': 'SUBMIT_SURVEY',
    'showLegend': false,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'showIcon': true,
    'iconStatus': 'DONE'
  }
];
export const completedReviveTabs = [
  {
    'id': 0,
    'header': 'Survey Type',
    'subHeader': '',
    'tableHeader': 'select Survey Type',
    'placeholderSearchText': 'Search Survey Type',
    'step': 'SURVEY_TYPE',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 1,
    'header': 'Path',
    'subHeader': '',
    'tableHeader': 'select Path',
    'placeholderSearchText': 'Search Path',
    'step': 'PATH',
    'showLegend': false,
    'showSkipButton': true,
    'labelSkipButton': 'Skip To Practice',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 2,
    'header': 'Elements',
    'subHeader': '',
    'tableHeader': 'Name Survey',
    'step': 'SUBMIT_SURVEY',
    'showLegend': false,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'showIcon': true,
    'iconStatus': 'DONE'
  }
];
export const completedTabsForLongForm = [
  {
    'id': 0,
    'header': 'Survey Type',
    'subHeader': '',
    'tableHeader': 'select Survey Type',
    'placeholderSearchText': 'Search Survey Type',
    'step': 'SURVEY_TYPE',
    'selectedItem': null,
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 1,
    'header': 'Elements',
    'subHeader': '',
    'tableHeader': 'Name Survey',
    'step': 'SUBMIT_SURVEY',
    'showLegend': false,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'showIcon': true,
    'iconStatus': 'DONE'
  }
];

export const completedTabSurvey = [
  {
    'id': 0,
    'header': 'Name Survey',
    'subHeader': '',
    'tableHeader': 'Name Survey',
    'step': 'SUBMIT_SURVEY',
    'showLegend': false,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'showIcon': true,
    'iconStatus': 'DONE'
  },
  {
    'id': 1,
    'header': 'Preloaded Variables',
    'subHeader': '',
    'tableHeader': 'Preloaded Variables',
    'step': 'PRELOAD_VARIABLE',
    'showLegend': false,
    'showSkipButton': false,
    'labelSkipButton': '',
    'showLongFormSurveyButton': false,
    'labelLongFormSurveyButton': '',
    'showIcon': true,
    'iconStatus': 'DONE'
  }
];

export const questionLogics = [
  {
    id: 1,
    text: 'And',
    value: 'AND'
  },
  {
    id: 2,
    text: 'Or',
    value: 'OR'
  },
  {
    id: 3,
    text: 'Move to a new Logic set',
    value: 'MOVE_TO_NEW_LOGIC_SET',
    selected: 'And'
  }
];

export const questionLogicAnswers = [
  {
    id: 1,
    text: 'None',
    value: 'NONE'
  },
  {
    id: 2,
    text: 'Once',
    value: 'ONCE'
  },
  {
    id: 3,
    text: 'Two Times',
    value: 'TWO_TIMES'
  },
  {
    id: 4,
    text: 'More than twice',
    value: 'MORE_THAN_TWICE'
  },
  {
    id: 5,
    text: 'Blank',
    value: 'BLANK'
  }
];

export const questionLogicConditions = [
  {
    id: 1,
    text: 'Equals',
    value: 'EQUALS'
  },
  {
    id: 2,
    text: 'Not equal to',
    value: 'NOT_EQUAL_TO'
  },
  {
    id: 3,
    text: 'Contains',
    value: 'CONTAINS'
  },
  {
    id: 4,
    text: 'Greater or equal to',
    value: 'GREATER_OR_EQUAL_TO'
  },
  {
    id: 5,
    text: 'Less than or equal to',
    value: 'LESS_THAN_OR_EQUAL_TO'
  },
  {
    id: 6,
    text: 'Greater than',
    value: 'GREATER_THAN'
  },
  {
    id: 7,
    text: 'less than',
    value: 'LESS_THAN'
  },
  {
    id: 8,
    text: 'Blank',
    value: 'BLANK'
  }
];

export const doneQuestionTypesContent = {
  currentContentIndex: 2,
  contentLeft: [
    {
      header: 'Question Type',
      questionTypes: [],
      currentQuestionType: null,
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHOOSE_QUESTION_TYPE
    },
    {
      header: '',
      questionTypes: [],
      currentQuestionType: null,
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL
    },
    {
      header: '',
      questionTypes: [],
      currentQuestionType: null,
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL
    }
  ],
  contentRight: [
    {
      header: 'Change Question Type',
      name: '', // add the name of selected question type
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL,
      type: constantQuestionTypesContent.QUESTION_TYPE_STEP.START_QUESTION_TYPE,
      needInputAnswer: false
    }, {
      header: 'Select Transformative Change Model',
      name: '',
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL,
      type: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL
    },
    {
      header: '',
      name: 'Go to Map',
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.MAP,
      type: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL
    }
  ]
};

export const initQuestionTypesContent = {
  currentContentIndex: 0,
  contentLeft: [
    {
      header: 'Question Type',
      questionTypes: [],
      currentQuestionType: null,
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHOOSE_QUESTION_TYPE
    }
  ],
  contentRight: [
    {
      header: 'Change Question Type',
      name: 'Choose Question Type',
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHOOSE_QUESTION_TYPE
    }, {
      header: 'Select Transformative Change Model',
      name: '',
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.CHANGE_MODEL
    },
    {
      header: '',
      name: 'Go to Map',
      step: constantQuestionTypesContent.QUESTION_TYPE_STEP.MAP
    }
  ]
};

export const percentSettings = {
  width: '45%',
  tooltip: 'always',
  interval: 5,
  disabled: false,
  piecewise: false,
  piecewiseLabel: true,
  style: {
    'margin': '80px auto'
  },
  data: ['0%', '25%', '50%', '75%', '100%'],
  piecewiseStyle: {
    'backgroundColor': '#E0DFE0',
    'visibility': 'visible',
    'width': '12px',
    'height': '12px'
  },
  sliderStyle: {
    'backgroundColor': '#D8D8D8'
  },
  processStyle: {
    'backgroundColor': '#1674CD'
  },
  piecewiseActiveStyle: {
    'backgroundColor': '#1674CD'
  },
  tooltipStyle: {
    'backgroundColor': '#1674CD',
    'borderColor': '#1674CD'
  },
  labelActiveStyle: {
    'color': '#1674CD'
  }
};

export const sliderSettings = {
  width: '5',
  tooltip: 'always',
  interval: 1,
  disabled: false,
  piecewise: false,
  piecewiseLabel: true,
  style: {
    'margin': '80px auto'
  },
  data: ['1', '10'],
  piecewiseStyle: {
    'backgroundColor': '#E0DFE0',
    'visibility': 'visible',
    'width': '12px',
    'height': '12px'
  },
  sliderStyle: {
    'backgroundColor': '#D8D8D8'
  },
  processStyle: {
    'backgroundColor': '#1674CD'
  },
  piecewiseActiveStyle: {
    'backgroundColor': '#1674CD'
  },
  tooltipStyle: {
    'backgroundColor': '#1674CD',
    'borderColor': '#1674CD'
  },
  labelActiveStyle: {
    'color': '#1674CD'
  }
};
// Question Domain
export const flourishDomains = [
  {
    text: 'Happiness and Life Satisfaction',
    value: 'HAPPINESS_AND_LIFE_SATISFACTION'
  },
  {
    text: 'Mental and Physical Health',
    value: 'MENTAL_AND_PHYSICAL_HEALTH'
  },
  {
    text: 'Meaning and Purpose',
    value: 'MEANING_AND_PURPOSE'
  },
  {
    text: 'Character and Virtue',
    value: 'CHARACTER_AND_VIRTUNE'
  },
  {
    text: 'Close Social Relationships',
    value: 'CLOSE_SOCIAL_RELATIONSHIPS'
  },
  {
    text: 'Financial and Material Stability',
    value: 'FINANCIAL_AND_MATERIAL_STABILITY'
  }
];

export const questionTypes = [
  {
    id: 1,
    name: 'Multiple Choice',
    leftIcon: 'list-ul',
    rightIcon: 'caret-right',
    type: 'icon',
    parent: true,
    expand: false,
    children: [
      {
        id: questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE,
        name: 'Multiple Choice',
        surveyQuestionAnswers: [
          {
            id: 100,
            title: 'Answer 1',
            text: '',
            value: ''
          },
          {
            id: 101,
            title: 'Answer 2',
            text: '',
            value: ''
          },
          {
            id: 102,
            title: 'Answer 3',
            text: '',
            value: ''
          },
          {
            id: 103,
            title: 'Answer 4',
            text: '',
            value: ''
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.ONE_FIVE_SCALE_MULTIPLE_CHOICE,
        name: '1-5 scale multiple choice',
        surveyQuestionAnswers: [
          {
            id: 115,
            title: 'Answer 1',
            text: '5',
            value: 5
          },
          {
            id: 114,
            title: 'Answer 2',
            text: '4',
            value: 4
          },
          {
            id: 113,
            title: 'Answer 3',
            text: '3',
            value: 3
          },
          {
            id: 112,
            title: 'Answer 4',
            text: '2',
            value: 2
          },
          {
            id: 111,
            title: 'Answer 5',
            text: '1',
            value: 1
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE_PICK_LIST,
        name: 'Pick List',
        surveyQuestionAnswers: [
          {
            id: 120,
            title: 'Answer 1',
            text: '',
            value: ''
          },
          {
            id: 121,
            title: 'Answer 2',
            text: '',
            value: ''
          },
          {
            id: 122,
            title: 'Answer 3',
            text: '',
            value: ''
          },
          {
            id: 123,
            title: 'Answer 4',
            text: '',
            value: ''
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.MULTIPLE_CHOICE_DATE_PICK,
        name: 'Date Pick',
        surveyQuestionAnswers: []
      }
    ]
  },
  {
    id: 2,
    name: 'Satisfaction',
    leftIcon: 'thumbs-up-down',
    rightIcon: 'caret-right',
    type: 'image',
    parent: true,
    expand: false,
    children: [
      {
        id: questionConstants.QUESTION_TYPES.SATISFACTION_LIKERT,
        name: 'Likert',
        surveyQuestionAnswers: [
          {
            id: 211,
            title: 'Answer 1',
            text: 'Strongly Agree',
            value: 5
          },
          {
            id: 212,
            title: 'Answer 2',
            text: 'Agree',
            value: 4
          },
          {
            id: 213,
            title: 'Answer 3',
            text: 'Neutral',
            value: 3
          },
          {
            id: 214,
            title: 'Answer 4',
            text: 'Disagree',
            value: 2
          },
          {
            id: 215,
            title: 'Answer 5',
            text: 'Strongly Disagree',
            value: 1
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.RATING_SATISFACTION,
        name: 'Rating Satisfaction',
        surveyQuestionAnswers: [
          {
            id: 221,
            title: 'Answer 1',
            text: 'Very Satisfied',
            value: 5
          },
          {
            id: 222,
            title: 'Answer 2',
            text: 'Satisfied',
            value: 4
          },
          {
            id: 223,
            title: 'Answer 3',
            text: 'Neutral',
            value: 3
          },
          {
            id: 224,
            title: 'Answer 4',
            text: 'Dissatisfied',
            value: 2
          },
          {
            id: 225,
            title: 'Answer 5',
            text: 'Very Dissatisfied',
            value: 1
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.SATISFACTION_RATING_THING,
        name: 'Rating Things',
        surveyQuestionAnswers: [
          {
            id: 231,
            title: 'Answer 1',
            text: '',
            value: ''
          },
          {
            id: 232,
            title: 'Answer 2',
            text: '',
            value: ''
          },
          {
            id: 233,
            title: 'Answer 3',
            text: '',
            value: ''
          },
          {
            id: 234,
            title: 'Answer 4',
            text: '',
            value: ''
          },
          {
            id: 235,
            title: 'Answer 5',
            text: '',
            value: ''
          }
        ]
      }
    ]
  },
  // {
  //   id: questionConstants.QUESTION_TYPES.PERCENTAGE,
  //   name: 'Percentage Scale',
  //   leftIcon: 'percentage-scale',
  //   rightIcon: 'caret-right',
  //   parent: true,
  //   expand: false,
  //   type: 'image',
  //   children: [
  //     {
  //       id: questionConstants.QUESTION_TYPES.PERCENTAGE_SCALE,
  //       name: 'Rating a percentage of something',
  //       description: 'The Percentage Scale is from 1 - 100 and increases in multiples of 5',
  //       defaultRating: 50,
  //       surveyQuestionAnswers: [
  //         {
  //           id: 115,
  //           title: 'Answer 1',
  //           text: '50',
  //           value: 50
  //         }
  //       ],
  //       settings: percentSettings
  //     }
  //   ]
  // },
  {
    id: questionConstants.QUESTION_TYPES.SCALE,
    name: 'Scale',
    leftIcon: 'percentage-scale',
    rightIcon: 'caret-right',
    parent: true,
    expand: false,
    type: 'image',
    children: [
      {
        id: questionConstants.QUESTION_TYPES.SLIDER,
        name: 'Slider',
        description: '',
        defaultRating: 0,
        flourishDomains: flourishDomains,
        questionDomainType: null,
        minValue: null,
        maxValue: null,
        optionalValue: 0,
        stepSize: 0,
        surveyQuestionAnswers: [
          {
            id: 115,
            title: 'Answer 1',
            text: '0',
            value: 0
          }
        ],
        settings: sliderSettings
      }
    ]
  },
  {
    id: questionConstants.QUESTION_TYPES.MULTIPLE_SELECT,
    name: 'Multi-Select',
    leftIcon: 'multi-select',
    rightIcon: 'caret-right',
    parent: true,
    expand: false,
    type: 'image',
    children: [
      {
        id: questionConstants.QUESTION_TYPES.MULTIPLE_SELECT_MORE_THAN_ONE_ANSWER,
        name: 'Allow users to pick more than one answer',
        surveyQuestionAnswers: [
          {
            id: 400,
            title: 'Answer 1',
            text: '',
            value: ''
          },
          {
            id: 401,
            title: 'Answer 2',
            text: '',
            value: ''
          },
          {
            id: 402,
            title: 'Answer 3',
            text: '',
            value: ''
          },
          {
            id: 403,
            title: 'Answer 4',
            text: '',
            value: ''
          }
        ]
      }
    ]
  },
  {
    id: questionConstants.QUESTION_TYPES.STACK_RANKING,
    name: 'Stack Ranking',
    leftIcon: 'stack-ranking',
    rightIcon: 'caret-right',
    type: 'image',
    parent: true,
    expand: false,
    children: [
      {
        id: questionConstants.QUESTION_TYPES.STACK_RANKING_HIGH_TOP,
        name: 'Highest ranking at top',
        surveyQuestionAnswers: [
          {
            id: 510,
            title: 'Answer 1',
            text: '',
            value: ''
          },
          {
            id: 511,
            title: 'Answer 2',
            text: '',
            value: ''
          },
          {
            id: 512,
            title: 'Answer 3',
            text: '',
            value: ''
          },
          {
            id: 513,
            title: 'Answer 4',
            text: '',
            value: ''
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.STACK_RANKING_LOW_BOTTOM,
        name: 'Lowest ranking at bottom',
        surveyQuestionAnswers: [
          {
            id: 520,
            title: 'Answer 1',
            text: '',
            value: ''
          },
          {
            id: 521,
            title: 'Answer 2',
            text: '',
            value: ''
          },
          {
            id: 522,
            title: 'Answer 3',
            text: '',
            value: ''
          },
          {
            id: 523,
            title: 'Answer 4',
            text: '',
            value: ''
          }
        ]
      }
    ]
  },
  {
    id: questionConstants.QUESTION_TYPES.OPEN_TEXT,
    name: 'Open Text',
    leftIcon: 'open-text',
    rightIcon: 'caret-right',
    parent: true,
    expand: false,
    type: 'image',
    children: [
      {
        id: questionConstants.QUESTION_TYPES.OPEN_TEXT_SHORT_ANSWER,
        name: 'Short Answer (character limit 255)',
        characters: 255,
        surveyQuestionAnswers: [
          {
            id: 661,
            title: 'Instruction for text box',
            text: '',
            characters: 255
          },
          {
            title: 'Answer 2',
            type: 'checkbox',
            text: ''
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.OPEN_TEXT_LONG_ANSWER,
        name: 'Long Answer (character limit 5000)',
        characters: 5000,
        surveyQuestionAnswers: [
          {
            id: 662,
            title: 'Instruction for text box',
            text: '',
            characters: 5000
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.OPEN_TEXT_CONSENT_DELIVERY,
        name: 'Consent Delivery',
        surveyQuestionAnswers: [
          {
            id: 663,
            title: '',
            text: '0',
            value: '0',
            validateQuestionAnswer: true
          }
        ]
      },
      {
        id: questionConstants.QUESTION_TYPES.OPEN_TEXT_NUMERIC_ANSWER,
        name: 'Numeric Answer',
        surveyQuestionAnswers: [
          {
            id: 664,
            title: 'Numeric Answer',
            text: '',
            labels: {
              min: 'Minimum',
              max: 'Maximum',
              default: 'Default',
              decimals: 'Number decimal places to be added (e.g 1 = .0, 2 = .00 and etc)',
              unit: 'Units (e.g pounds, kilo, dollars, etc)'
            }
          }
        ]
      }
    ]
  }
];

export const variableType = [
  {
    id: 'CALCULATION_VARIABLE',
    name: 'Calculate Variable',
    leftIcon: null,
    rightIcon: null,
    parent: false,
    expand: false,
    type: 'image',
    children: []
  }
];

export default {
  completedTabs,
  completedReviveTabs,
  completedTabsForLongForm,
  doneQuestionTypesContent,
  initQuestionTypesContent,
  percentSettings,
  sliderSettings,
  flourishDomains,
  questionTypes,
  variableType
};
